import type { FunctionComponent } from "react";

import Card from "~/components/Card/Card";
import CardValue from "~/components/Card/components/CardValue.tsx";
import type { EInvoiceBuyer } from "~/modules/billing/api/eInvoice/eInvoiceTypes.ts";

import EInvoiceAddressBlock from "./EInvoiceAddressBlock.tsx";
import EInvoiceSectionErrors from "./EInvoiceSectionErrors.tsx";

type Props = {
	buyer: EInvoiceBuyer;
	errors?: string[];
};

const EInvoiceBuyerSection: FunctionComponent<Props> = ({ buyer, errors }) => (
	<Card title="Käufer">
		<EInvoiceSectionErrors errors={errors} />
		<div className="flex flex-col gap-3">
			{buyer.name && <CardValue label="Name">{buyer.name}</CardValue>}
			{buyer.address !== null && (
				<CardValue label="Adresse">
					<EInvoiceAddressBlock address={buyer.address} />
				</CardValue>
			)}
		</div>
	</Card>
);

export default EInvoiceBuyerSection;
